module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-14-c352e978077fc0ae4bf572a2a92d497e.jpg";